import type { ColorsType } from './ColorsType.ts';
// THIS IS A GENERATED FILE, DO NOT EDIT BY HAND!
// Run "pnpm generate-colors" in the "web" package to update the contents of this file!
export function collectColors(element: Element): ColorsType {
  const style = getComputedStyle(element);
  return {
    primary: style.getPropertyValue('--primary').trim(),
    white: style.getPropertyValue('--white').trim(),
    black: style.getPropertyValue('--black').trim(),
    whiteAlpha24: style.getPropertyValue('--white-alpha24').trim(),
    whiteAlpha40: style.getPropertyValue('--white-alpha40').trim(),
    positiveChange: style.getPropertyValue('--positive-change').trim(),
    positiveChangeLight: style.getPropertyValue('--positive-change-light').trim(),
    negativeChange: style.getPropertyValue('--negative-change').trim(),
    sell: style.getPropertyValue('--sell').trim(),
    sellLight: style.getPropertyValue('--sell-light').trim(),
    buy: style.getPropertyValue('--buy').trim(),
    buyLight: style.getPropertyValue('--buy-light').trim(),
    priceNeutral: style.getPropertyValue('--price-neutral').trim(),
    border: style.getPropertyValue('--border').trim(),
    background: style.getPropertyValue('--background').trim(),
    backgroundSecondary: style.getPropertyValue('--background-secondary').trim(),
    backgroundWarning: style.getPropertyValue('--background-warning').trim(),
    backgroundWarningAlpha40: style.getPropertyValue('--background-warning-alpha40').trim(),
    backgroundSuccess: style.getPropertyValue('--background-success').trim(),
    backgroundInfo: style.getPropertyValue('--background-info').trim(),
    backgroundError: style.getPropertyValue('--background-error').trim(),
    warning: style.getPropertyValue('--warning').trim(),
    error: style.getPropertyValue('--error').trim(),
    errorAlpha40: style.getPropertyValue('--error-alpha40').trim(),
    success: style.getPropertyValue('--success').trim(),
    info: style.getPropertyValue('--info').trim(),
    badge: style.getPropertyValue('--badge').trim(),
    link: style.getPropertyValue('--link').trim(),
    shadow: style.getPropertyValue('--shadow').trim(),
    blue: style.getPropertyValue('--blue').trim(),
    hover: style.getPropertyValue('--hover').trim(),
    hoverSecondary: style.getPropertyValue('--hover-secondary').trim(),
    purple500: style.getPropertyValue('--purple500').trim(),
    purple100: style.getPropertyValue('--purple100').trim(),
    purple500Alpha10: style.getPropertyValue('--purple500-alpha10').trim(),
    purple500HighlightBackground: style.getPropertyValue('--purple500-highlight-background').trim(),
    purple500HighlightText: style.getPropertyValue('--purple500-highlight-text').trim(),
    yellow: style.getPropertyValue('--yellow').trim(),
    turquoise: style.getPropertyValue('--turquoise').trim(),
    aubergine: style.getPropertyValue('--aubergine').trim(),
    orange: style.getPropertyValue('--orange').trim(),
    redAlpha40: style.getPropertyValue('--red-alpha40').trim(),
    greenHighlight: style.getPropertyValue('--green-highlight').trim(),
    redHighlight: style.getPropertyValue('--red-highlight').trim(),
    addChartModalFavorite: style.getPropertyValue('--add-chart-modal-favorite').trim(),
    addChartModalBidding: style.getPropertyValue('--add-chart-modal-bidding').trim(),
    addChartModalHover: style.getPropertyValue('--add-chart-modal-hover').trim(),
    addChartModalBoxShadow: style.getPropertyValue('--add_chart_modal_boxShadow').trim(),
    grey: style.getPropertyValue('--grey').trim(),
    grey100: style.getPropertyValue('--grey100').trim(),
    grey200: style.getPropertyValue('--grey200').trim(),
    grey300: style.getPropertyValue('--grey300').trim(),
    grey400: style.getPropertyValue('--grey400').trim(),
    grey500: style.getPropertyValue('--grey500').trim(),
    grey600: style.getPropertyValue('--grey600').trim(),
    grey800: style.getPropertyValue('--grey800').trim(),
    grey300Alpha24: style.getPropertyValue('--grey300-alpha24').trim(),
    headerBackground: style.getPropertyValue('--header-background').trim(),
    headerText: style.getPropertyValue('--header-text').trim(),
    headerBorder: style.getPropertyValue('--header-border').trim(),
    headerHover: style.getPropertyValue('--header-hover').trim(),
    headerHoverText: style.getPropertyValue('--header-hover-text').trim(),
    containerBackground: style.getPropertyValue('--container-background').trim(),
    widgetBackground: style.getPropertyValue('--widget-background').trim(),
    widgetBackgroundSecondary: style.getPropertyValue('--widget-background-secondary').trim(),
    widgetBackgroundForm: style.getPropertyValue('--widget-background-form').trim(),
    widgetDivider: style.getPropertyValue('--widget-divider').trim(),
    widgetContent: style.getPropertyValue('--widget-content').trim(),
    widgetHeaderIcon: style.getPropertyValue('--widget-header-icon').trim(),
    widgetShadow: style.getPropertyValue('--widget-shadow').trim(),
    tooltipBackground: style.getPropertyValue('--tooltip-background').trim(),
    tooltipText: style.getPropertyValue('--tooltip-text').trim(),
    textPrimary: style.getPropertyValue('--text-primary').trim(),
    textPrimaryLight: style.getPropertyValue('--text-primary-light').trim(),
    textSecondary: style.getPropertyValue('--text-secondary').trim(),
    textDisabled: style.getPropertyValue('--text-disabled').trim(),
    textDisabledDark: style.getPropertyValue('--text-disabled-dark').trim(),
    textOnWarning: style.getPropertyValue('--text-on-warning').trim(),
    textOnAccordion: style.getPropertyValue('--text-on-accordion').trim(),
    textHelper: style.getPropertyValue('--text-helper').trim(),
    modalHeaderText: style.getPropertyValue('--modal-header-text').trim(),
    modalBackground: style.getPropertyValue('--modal-background').trim(),
    modalDivider: style.getPropertyValue('--modal-divider').trim(),
    modalHighlight: style.getPropertyValue('--modal-highlight').trim(),
    modalError: style.getPropertyValue('--modal-error').trim(),
    modalWarning: style.getPropertyValue('--modal-warning').trim(),
    modalBackgroundHighlight: style.getPropertyValue('--modal-background-highlight').trim(),
    modalContent: style.getPropertyValue('--modal-content').trim(),
    modalFooterSecondaryButtonBorder: style.getPropertyValue('--modal-footer-secondary-button-border').trim(),
    modalFooterSecondaryButtonBg: style.getPropertyValue('--modal-footer-secondary-button-bg').trim(),
    currencyModalContentBackground: style.getPropertyValue('--currency-modal-content-background').trim(),
    currencyModalSummaryBackground: style.getPropertyValue('--currency-modal-summary-background').trim(),
    currencyTime: style.getPropertyValue('--currency-time').trim(),
    textSwitchActive: style.getPropertyValue('--text-switch-active').trim(),
    textSwitchBackground: style.getPropertyValue('--text-switch-background').trim(),
    textSwitchActiveText: style.getPropertyValue('--text-switch-active-text').trim(),
    textSwitchBorder: style.getPropertyValue('--text-switch-border').trim(),
    gridBackground: style.getPropertyValue('--grid-background').trim(),
    gridHeaderBackground: style.getPropertyValue('--grid-header-background').trim(),
    gridOddRowBackground: style.getPropertyValue('--grid-odd-row-background').trim(),
    gridEvenRowBackground: style.getPropertyValue('--grid-even-row-background').trim(),
    gridPositiveRowBackground: style.getPropertyValue('--grid-positive-row-background').trim(),
    gridNegativeRowBackground: style.getPropertyValue('--grid-negative-row-background').trim(),
    gridSubContent: style.getPropertyValue('--grid-sub-content').trim(),
    gridSecondaryText: style.getPropertyValue('--grid-secondary-text').trim(),
    gridHighlightBg: style.getPropertyValue('--grid-highlight-bg').trim(),
    gridGreenValue: style.getPropertyValue('--grid-green-value').trim(),
    gridRedValue: style.getPropertyValue('--grid-red-value').trim(),
    portfolioLegendPercentage: style.getPropertyValue('--portfolio-legend-percentage').trim(),
    portfolioPieBorder: style.getPropertyValue('--portfolio-pie-border').trim(),
    portfolioRingGreen: style.getPropertyValue('--portfolio-ring-green').trim(),
    portfolioRingRed: style.getPropertyValue('--portfolio-ring-red').trim(),
    portfolioLabelWhite: style.getPropertyValue('--portfolio-label-white').trim(),
    portfolioLabelBlack: style.getPropertyValue('--portfolio-label-black').trim(),
    portfolioNegativePie: style.getPropertyValue('--portfolio-negative-pie').trim(),
    buttonPrimary: style.getPropertyValue('--button-primary').trim(),
    buttonPrimaryAlpha40: style.getPropertyValue('--button-primary-alpha40').trim(),
    buttonPrimaryText: style.getPropertyValue('--button-primary-text').trim(),
    buttonPrimaryTextAlpha60: style.getPropertyValue('--button-primary-text-alpha60').trim(),
    buttonEmphasize: style.getPropertyValue('--button-emphasize').trim(),
    buttonEmphasizeAlpha40: style.getPropertyValue('--button-emphasize-alpha40').trim(),
    buttonEmphasizeText: style.getPropertyValue('--button-emphasize-text').trim(),
    buttonEmphasizeTextAlpha60: style.getPropertyValue('--button-emphasize-text-alpha60').trim(),
    buttonSecondary: style.getPropertyValue('--button-secondary').trim(),
    buttonSecondaryAlpha40: style.getPropertyValue('--button-secondary-alpha40').trim(),
    buttonSecondaryText: style.getPropertyValue('--button-secondary-text').trim(),
    buttonSecondaryTextAlpha60: style.getPropertyValue('--button-secondary-text-alpha60').trim(),
    buttonSecondaryContained: style.getPropertyValue('--button-secondary-contained').trim(),
    buttonSecondaryContainedAlpha40: style.getPropertyValue('--button-secondary-contained-alpha40').trim(),
    buttonSecondaryContainedText: style.getPropertyValue('--button-secondary-contained-text').trim(),
    buttonSecondaryContainedTextAlpha60: style.getPropertyValue('--button-secondary-contained-text-alpha60').trim(),
    buttonSecondaryContainedBorder: style.getPropertyValue('--button-secondary-contained-border').trim(),
    buttonSell: style.getPropertyValue('--button-sell').trim(),
    buttonSellAlpha50: style.getPropertyValue('--button-sell-alpha50').trim(),
    buttonBuy: style.getPropertyValue('--button-buy').trim(),
    buttonBuyAlpha50: style.getPropertyValue('--button-buy-alpha50').trim(),
    buttonDisabled: style.getPropertyValue('--button-disabled').trim(),
    buttonFeedbackBorder: style.getPropertyValue('--button-feedback-border').trim(),
    buttonFeedbackIcon: style.getPropertyValue('--button-feedback-icon').trim(),
    buttonFeedbackSelectedBackground: style.getPropertyValue('--button-feedback-selected-background').trim(),
    buttonFeedbackSelectedContent: style.getPropertyValue('--button-feedback-selected-content').trim(),
    feedbackDndBorder: style.getPropertyValue('--feedback-dnd-border').trim(),
    feedbackDndBackground: style.getPropertyValue('--feedback-dnd-background').trim(),
    feedbackDndBackgroundDragOver: style.getPropertyValue('--feedback-dnd-background-drag-over').trim(),
    feedbackFileRowBackground: style.getPropertyValue('--feedback-file-row-background').trim(),
    feedbackInfo: style.getPropertyValue('--feedback-info').trim(),
    feedbackInfoText: style.getPropertyValue('--feedback-info-text').trim(),
    feedbackWarningText: style.getPropertyValue('--feedback-warning-text').trim(),
    feedbackConfirmText: style.getPropertyValue('--feedback-confirm-text').trim(),
    feedbackConfirmBold: style.getPropertyValue('--feedback-confirm-bold').trim(),
    inputBackground: style.getPropertyValue('--input-background').trim(),
    inputAndrormentBackground: style.getPropertyValue('--input-androrment-background').trim(),
    inputBorder: style.getPropertyValue('--input-border').trim(),
    inputIcon: style.getPropertyValue('--input-icon').trim(),
    inputHelperText: style.getPropertyValue('--input-helper-text').trim(),
    inputBackgroundDisabled: style.getPropertyValue('--input-background-disabled').trim(),
    inputTextDisabled: style.getPropertyValue('--input-text-disabled').trim(),
    tabSelectedBackground: style.getPropertyValue('--tab-selected-background').trim(),
    tabBackground: style.getPropertyValue('--tab-background').trim(),
    tabSelectedText: style.getPropertyValue('--tab-selected-text').trim(),
    tabText: style.getPropertyValue('--tab-text').trim(),
    cashActionModalBackground: style.getPropertyValue('--cash-action-modal-background').trim(),
    cashActionTitleText: style.getPropertyValue('--cash-action-title-text').trim(),
    cashActionDivider: style.getPropertyValue('--cash-action-divider').trim(),
    cashActionExternalCopiedIcon: style.getPropertyValue('--cash-action-external-copied-icon').trim(),
    cashActionMutedText: style.getPropertyValue('--cash-action-muted-text').trim(),
    popoverTitle: style.getPropertyValue('--popover-title').trim(),
    popoverBackground: style.getPropertyValue('--popover-background').trim(),
    popoverContent: style.getPropertyValue('--popover-content').trim(),
    popoverContentBorder: style.getPropertyValue('--popover-content-border').trim(),
    popoverBorder: style.getPropertyValue('--popover-border').trim(),
    popoverSvgFill: style.getPropertyValue('--popover-svg-fill').trim(),
    popoverButtonOutline: style.getPropertyValue('--popover-button-outline').trim(),
    popoverButtonText: style.getPropertyValue('--popover-button-text').trim(),
    cashPopoverActionsBackground: style.getPropertyValue('--cash-popover-actions-background').trim(),
    cashPopoverActionPrimaryBackground: style.getPropertyValue('--cash-popover-action-primary-background').trim(),
    cashPopoverActionPrimaryText: style.getPropertyValue('--cash-popover-action-primary-text').trim(),
    cashPopoverActionOutlineBackground: style.getPropertyValue('--cash-popover-action-outline-background').trim(),
    cashPopoverActionOutlineText: style.getPropertyValue('--cash-popover-action-outline-text').trim(),
    cashPopoverEmptyText: style.getPropertyValue('--cash-popover-empty-text').trim(),
    searchInput: style.getPropertyValue('--search-input').trim(),
    searchResultSelected: style.getPropertyValue('--search-result-selected').trim(),
    searchResultSelectedBackground: style.getPropertyValue('--search-result-selected-background').trim(),
    searchResultBackground: style.getPropertyValue('--search-result-background').trim(),
    consentBackground: style.getPropertyValue('--consent-background').trim(),
    consentText: style.getPropertyValue('--consent-text').trim(),
    snackbarContentPinned: style.getPropertyValue('--snackbar-content-pinned').trim(),
    snackbarContent: style.getPropertyValue('--snackbar-content').trim(),
    snackbarWarningLight: style.getPropertyValue('--snackbar-warning-light').trim(),
    snackbarWarning: style.getPropertyValue('--snackbar-warning').trim(),
    datePickerContent: style.getPropertyValue('--date-picker-content').trim(),
    menuBorder: style.getPropertyValue('--menu-border').trim(),
    menuItemIcon: style.getPropertyValue('--menu-item-icon').trim(),
    menuItem: style.getPropertyValue('--menu-item').trim(),
    menuItemActive: style.getPropertyValue('--menu-item-active').trim(),
    menuItemActiveText: style.getPropertyValue('--menu-item-active-text').trim(),
    menuSubmenuActive: style.getPropertyValue('--menu-submenu-active').trim(),
    menuItemCollapsedHover: style.getPropertyValue('--menu-item-collapsed-hover').trim(),
    menuCollapsedPopover: style.getPropertyValue('--menu-collapsed-popover').trim(),
    menuSubitemHover: style.getPropertyValue('--menu-subitem-hover').trim(),
    selectedBackground: style.getPropertyValue('--selected-background').trim(),
    selectorBackground: style.getPropertyValue('--selector-background').trim(),
    selectorCircle: style.getPropertyValue('--selector-circle').trim(),
    backdrop: style.getPropertyValue('--backdrop').trim(),
    progressBarBackground: style.getPropertyValue('--progress-bar-background').trim(),
    progressBarBorder: style.getPropertyValue('--progress-bar-border').trim(),
    progressBarIndefiniteTransparent1: style.getPropertyValue('--progress-bar-indefinite-transparent-1').trim(),
    progressBarIndefiniteTransparent2: style.getPropertyValue('--progress-bar-indefinite-transparent-2').trim(),
    progressBarIndefiniteTransparent3: style.getPropertyValue('--progress-bar-indefinite-transparent-3').trim(),
    progressBarIndefiniteContrast1: style.getPropertyValue('--progress-bar-indefinite-contrast-1').trim(),
    progressBarIndefiniteContrast2: style.getPropertyValue('--progress-bar-indefinite-contrast-2').trim(),
    progressBarIndefiniteContrast3: style.getPropertyValue('--progress-bar-indefinite-contrast-3').trim(),
    chartErsteLogo: style.getPropertyValue('--chart-erste-logo').trim(),
    loginBackground: style.getPropertyValue('--login-background').trim(),
    loginSecondaryBackground: style.getPropertyValue('--login-secondary-background').trim(),
    loginErsteIcon: style.getPropertyValue('--login-erste-icon').trim(),
    loginDetailsText: style.getPropertyValue('--login-details-text').trim(),
    certificate: style.getPropertyValue('--certificate').trim(),
    compensationNote: style.getPropertyValue('--compensationNote').trim(),
    share: style.getPropertyValue('--share').trim(),
    investmentUnit: style.getPropertyValue('--investmentUnit').trim(),
    option: style.getPropertyValue('--option').trim(),
    currency: style.getPropertyValue('--currency').trim(),
    future: style.getPropertyValue('--future').trim(),
    customLayoutDropzone: style.getPropertyValue('--custom-layout-dropzone').trim(),
    customLayoutDropzoneBorder: style.getPropertyValue('--custom-layout-dropzone-border').trim(),
    customLayoutDropzoneWidgetTypeBackground: style
      .getPropertyValue('--custom-layout-dropzone-widget-type-background')
      .trim(),
    shadowAlpha6: style.getPropertyValue('--shadow-alpha6').trim(),
    shadowAlpha10: style.getPropertyValue('--shadow-alpha10').trim(),
    shadowAlpha15: style.getPropertyValue('--shadow-alpha15').trim(),
    shadowAlpha20: style.getPropertyValue('--shadow-alpha20').trim(),
    moneyMask: style.getPropertyValue('--money-mask').trim(),
    moneyMaskInverse: style.getPropertyValue('--money-mask-inverse').trim(),
    collateralSummaryText: style.getPropertyValue('--collateral-summary-text').trim(),
    codeInputFieldBackground: style.getPropertyValue('--code-input-field-background').trim(),
    codeInputFieldBorder: style.getPropertyValue('--code-input-field-border').trim(),
    codeInputFieldBorderActive: style.getPropertyValue('--code-input-field-border-active').trim(),
    codeInputFieldOutlineActive: style.getPropertyValue('--code-input-field-outline-active').trim(),
    codeInputFieldText: style.getPropertyValue('--code-input-field-text').trim(),
    codeInputModalDescription: style.getPropertyValue('--code-input-modal-description').trim(),
    codeInputModalCodeLabel: style.getPropertyValue('--code-input-modal-code-label').trim(),
    codeInputModalIcon: style.getPropertyValue('--code-input-modal-icon').trim(),
    codeInputModalError: style.getPropertyValue('--code-input-modal-error').trim(),
    historicalPvTabActiveBg: style.getPropertyValue('--historical-pv-tab-active-bg').trim(),
    historicalPvTabActiveText: style.getPropertyValue('--historical-pv-tab-active-text').trim(),
    historicalPvTabInactiveBg: style.getPropertyValue('--historical-pv-tab-inactive-bg').trim(),
    historicalPvTabHover: style.getPropertyValue('--historical-pv-tab-hover').trim(),
    historicalPvTabInactiveText: style.getPropertyValue('--historical-pv-tab-inactive-text').trim(),
    historicalPvTitle: style.getPropertyValue('--historical-pv-title').trim(),
    historicalPvSubTitle: style.getPropertyValue('--historical-pv-subTitle').trim(),
    historicalChartLine: style.getPropertyValue('--historical-chart-line').trim(),
    historicalChartLineNegative: style.getPropertyValue('--historical-chart-line-negative').trim(),
    historicalChartAreaStart: style.getPropertyValue('--historical-chart-area-start').trim(),
    historicalChartAreaEnd: style.getPropertyValue('--historical-chart-area-end').trim(),
    historicalChartAxisText: style.getPropertyValue('--historical-chart-axis-text').trim(),
    historicalChartGridColor: style.getPropertyValue('--historical-chart-grid-color').trim(),
    historicalChartTooltipCircle: style.getPropertyValue('--historical-chart-tooltip-circle').trim(),
    historicalChartTooltipCircleBorder: style.getPropertyValue('--historical-chart-tooltip-circle-border').trim(),
    historicalChartTooltipInnerCircle: style.getPropertyValue('--historical-chart-tooltip-inner-circle').trim(),
    historicalPvBalanceDate: style.getPropertyValue('--historical-pv-balance-date').trim(),
    historicalPvBalanceValue: style.getPropertyValue('--historical-pv-balance-value').trim(),
    statTagPositive: style.getPropertyValue('--stat-tag-positive').trim(),
    statTagPositiveBg: style.getPropertyValue('--stat-tag-positive-bg').trim(),
    statTagNegative: style.getPropertyValue('--stat-tag-negative').trim(),
    statTagNegativeBg: style.getPropertyValue('--stat-tag-negative-bg').trim(),
    statTagNeutral: style.getPropertyValue('--stat-tag-neutral').trim(),
    statTagNeutralBg: style.getPropertyValue('--stat-tag-neutral-bg').trim(),
    mobileAppBannerBackground: style.getPropertyValue('--mobile-app-banner-background').trim(),
    mobileAppBannerOverlay: style.getPropertyValue('--mobile-app-banner-overlay').trim(),
    mobileAppBannerTitle: style.getPropertyValue('--mobile-app-banner-title').trim(),
    mobileAppBannerText: style.getPropertyValue('--mobile-app-banner-text').trim(),
    mobileAppBannerCheckIcon: style.getPropertyValue('--mobile-app-banner-check-icon').trim(),
    mobileAppBannerCloseIcon: style.getPropertyValue('--mobile-app-banner-close-icon').trim(),
    mobileAppBannerAppIconBackground: style.getPropertyValue('--mobile-app-banner-app-icon-background').trim(),
    indexRowChartPositiveStroke: style.getPropertyValue('--index-row-chart-positive-stroke').trim(),
    indexRowChartPositiveGradientStart: style.getPropertyValue('--index-row-chart-positive-gradient-start').trim(),
    indexRowChartPositiveGradientMid: style.getPropertyValue('--index-row-chart-positive-gradient-mid').trim(),
    indexRowChartPositiveGradientEnd: style.getPropertyValue('--index-row-chart-positive-gradient-end').trim(),
    indexRowChartNegativeStroke: style.getPropertyValue('--index-row-chart-negative-stroke').trim(),
    indexRowChartNegativeGradientStart: style.getPropertyValue('--index-row-chart-negative-gradient-start').trim(),
    indexRowChartNegativeGradientMid: style.getPropertyValue('--index-row-chart-negative-gradient-mid').trim(),
    indexRowChartNegativeGradientEnd: style.getPropertyValue('--index-row-chart-negative-gradient-end').trim(),
    collareralSummaryTextSecondary: style.getPropertyValue('--collareral-summary-text-secondary').trim() || undefined,
    paleBlue: style.getPropertyValue('--pale-blue').trim() || undefined,
    x: style.getPropertyValue('--x').trim() || undefined,
    shadowAlpha5: style.getPropertyValue('--shadow-alpha5').trim() || undefined,
    collateralSummarySecondary: style.getPropertyValue('--collateral-summary-secondary').trim() || undefined,
  };
}
